import { createLucideIcon } from "lucide-react";

export const Delete = createLucideIcon(
    "Delete",
    [
        [
            "path",
            {
                d: "M14.5 16.5L14.5 10.5",
                key: "1tf4as",
            },
        ],
        [
            "path",
            {
                d: "M16.0557 5.5L15.3731 4.0917C14.9196 3.1563 14.6928 2.6885 14.3017 2.3968C14.215 2.3321 14.1231 2.2745 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.9957 2.2341C9.8981 2.286 9.805 2.3459 9.7173 2.4132C9.3216 2.7167 9.1006 3.2016 8.6586 4.1713L8.0529 5.5",
                key: "1gw08n",
            },
        ],
        [
            "path",
            {
                d: "M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5",
                key: "13lqym",
            },
        ],
        [
            "path",
            {
                d: "M3 5.5H21",
                key: "zsha01",
            },
        ],
        [
            "path",
            {
                d: "M9.5 16.5L9.5 10.5",
                key: "l6eggt",
            },
        ],
    ],
);
